'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEvent = exports.getEvents = undefined;

var _fp = require('lodash/fp');

var _fp2 = _interopRequireDefault(_fp);

var _bdcoreUtilities = require('@bd/bdcore-utilities');

var _bdcoreNamedRoutes = require('@bd/bdcore-named-routes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routeParamsToPropsMap = {
  eventIdentifier: {
    path: '$',
    resolve: function resolve(state, event) {
      var date = new Date(_fp2.default.get('date', event));
      return _fp2.default.get('title', event) + '-' + date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
    }
  }
};

var getEvents = exports.getEvents = function getEvents(_ref, _ref2) {
  var _ref$cloudData = _ref.cloudData;
  _ref$cloudData = _ref$cloudData === undefined ? {} : _ref$cloudData;
  var events = _ref$cloudData.events;
  var _ref2$builderId = _ref2.builderId,
      builderId = _ref2$builderId === undefined ? _bdcoreUtilities.ConfigStore.getConfig('builder_id') : _ref2$builderId;

  return _fp2.default.get(builderId + '.data', events);
};

var getEvent = exports.getEvent = function getEvent(state, _ref3) {
  var match = _ref3.match,
      _ref3$builderId = _ref3.builderId,
      builderId = _ref3$builderId === undefined ? _bdcoreUtilities.ConfigStore.getConfig('builder_id') : _ref3$builderId;
  var _state$cloudData = state.cloudData;
  _state$cloudData = _state$cloudData === undefined ? {} : _state$cloudData;
  var events = _state$cloudData.events;


  var testResult = _fp2.default.getOr([], builderId + '.data', events).reduce(function (result, item) {
    if (result === undefined && match && (0, _bdcoreNamedRoutes.paramsMatch)(match.params, routeParamsToPropsMap, item, true, state)) {
      return item;
    }

    return result;
  }, undefined);

  return testResult;
};

exports.default = getEvents;


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-data/build/Events/selectors.js
// module id = 934
// module chunks = 0